import smoothscroll from 'smoothscroll-polyfill';
import './scripts/vue';
import './scripts/size-guide';

smoothscroll.polyfill();
